export default "__VITE_ASSET__Cq1HkWd8__"